import { general } from './general'

export const mutations = Object.assign({}, general)
